import { render, staticRenderFns } from "./TestimonialsTable.vue?vue&type=template&id=0aeab237"
import script from "./TestimonialsTable.vue?vue&type=script&lang=js"
export * from "./TestimonialsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports